<template>
  <div>
    <r-modal
      v-model:isactive="internalActive"
      :title="'Değerler - ' + (definition?.name || '')"
      width="700px"
    >
      <div v-if="valuesLoaded">
        <div v-if="errorMessage" class="pv-alert-msg">
          {{ errorMessage }}
        </div>
        <r-data-list :headdata="valueHeads" :listdata="values" :opt="valueOpts">
          <template v-slot:titleextrabuttons>
            <r-btn @click="addValue">Yeni Değer</r-btn>
            <r-btn
              type="secondary"
              @click="saveValuesReorder"
              v-if="values && values.length > 0"
              >Sıralamayı Kaydet</r-btn
            >
          </template>
          <template v-slot:rowextrabtn="{ datarow }">
            <r-btn @click="openEditValue(datarow)">Düzenle</r-btn>
            <r-btn
              :type="datarow.isActive ? 'danger' : 'success'"
              @click="toggleValue(datarow)"
              >{{ datarow.isActive ? "Pasif Et" : "Aktif Et" }}</r-btn
            >
            <r-btn type="danger" @click="deleteValue(datarow)">Sil</r-btn>
          </template>
        </r-data-list>
      </div>
    </r-modal>

    <r-modal
      v-model:isactive="editValueModal"
      title="Değer Düzenle"
      width="500px"
    >
      <r-input v-model="editValueData.value" label="Değer" class="r-mb-16" />
      <r-input
        v-model="editValueData.displayText"
        label="Görüntü Metni"
        class="r-mb-16"
      />
      <r-input
        v-model="editValueData.sortOrder"
        label="Sıra"
        type="number"
        class="r-mb-16"
      />
      <r-checkbox
        v-model="editValueData.isActive"
        label="Aktif"
        class="r-mb-16"
      />
      <template v-slot:otherbuttons>
        <r-btn bgcolor="#15880d" @click="saveValueEdit" size="medium"
          >Kaydet</r-btn
        >
      </template>
    </r-modal>
  </div>
</template>

<script>
import { ref, computed, watch, onBeforeMount } from "vue";
import { useStore } from "vuex";

export default {
  name: "PropertyValuesModal",
  props: {
    isactive: {
      type: Boolean,
      default: false
    },
    definition: {
      type: Object,
      default: null
    }
  },
  setup(props, { emit }) {
    const store = useStore();
    const values = ref([]);
    const valuesLoaded = ref(false);
    const errorMessage = ref("");
    const isSaving = ref(false);

    const internalActive = computed({
      get() {
        return props.isactive;
      },
      set(val) {
        emit("update:isactive", val);
      }
    });

    const valueHeads = computed(() => [
      { title: "Değer", key: "value", style: { width: "35%" } },
      { title: "Görüntü Metni", key: "displayText", style: { width: "35%" } },
      {
        title: "Aktif",
        key: "isActive",
        type: "checkbox",
        style: { width: "10%", justifyContent: "center" }
      },
      { title: "Sıra", key: "sortOrder", style: { width: "10%" } }
    ]);

    const valueOpts = ref({
      title: "Değerler",
      buttons: {
        style: { width: "20%" }
      }
    });

    const loadValues = async () => {
      if (!props.definition || !props.definition.id) {
        values.value = [];
        valuesLoaded.value = false;
        return;
      }
      valuesLoaded.value = false;
      const res = await store.dispatch("getDatas", {
        api: `PropertyDefinitions/${props.definition.id}/values`
      });
      const arr = res && (res.data ?? res.Data);
      values.value = Array.isArray(arr) ? arr : [];
      valuesLoaded.value = true;
    };

    const addValue = () => {
      if (!props.definition || !props.definition.id) return;
      values.value.push({
        id: null,
        propertyDefinitionId: props.definition.id,
        value: "",
        displayText: "",
        isActive: true,
        sortOrder: (values.value.length || 0) + 1
      });
    };

    const editValueModal = ref(false);
    const editValueData = ref({
      id: null,
      propertyDefinitionId: null,
      value: "",
      displayText: "",
      isActive: true,
      sortOrder: 1
    });

    const openEditValue = v => {
      editValueData.value = {
        id: v.id || null,
        propertyDefinitionId: v.propertyDefinitionId || props.definition?.id,
        value: v.value || "",
        displayText: v.displayText || "",
        isActive: v.isActive !== undefined ? v.isActive : true,
        sortOrder: v.sortOrder || 1
      };
      editValueModal.value = true;
    };

    const saveValueEdit = async () => {
      if (isSaving.value) return;
      isSaving.value = true;
      try {
        const v = { ...editValueData.value };
        if (!v.value) return;

      const dto = {
        id: v.id || null,
        propertyDefinitionId: v.propertyDefinitionId || props.definition?.id,
        value: v.value,
        displayText: v.displayText,
        sortOrder: Number(v.sortOrder || 1),
        isActive: v.isActive
      };

      const hasId = !!dto.id && dto.id > 0;
      const api = hasId
        ? "PropertyDefinitions/UpdateValue"
        : "PropertyDefinitions/AddValue";

      const res = await store.dispatch("postDatas", { api, data: dto });
      if (res && res.result) {
        errorMessage.value = "";
        await loadValues();
        editValueModal.value = false;
      } else {
        errorMessage.value =
          res?.msgDetail?.msg ||
          "Özellik değeri kaydedilirken bir hata oluştu.";
      }
      } finally {
        isSaving.value = false;
      }
    };

    const deleteValue = async v => {
      if (isSaving.value) return;
      isSaving.value = true;
      try {
        const res = await store.dispatch("postDatas", {
          api: `PropertyDefinitions/values/${v.id}/delete`,
          data: {}
        });
        if (res && res.result) {
          errorMessage.value = "";
          await loadValues();
        } else {
          errorMessage.value =
            res?.msgDetail?.msg || "Özellik değeri silinemedi.";
          await loadValues();
        }
      } finally {
        isSaving.value = false;
      }
    };

    const toggleValue = async v => {
      if (isSaving.value) return;
      isSaving.value = true;
      try {
        await store.dispatch("postDatas", {
          api: `PropertyDefinitions/values/${v.id}/toggle`,
          data: {}
        });
        await loadValues();
      } finally {
        isSaving.value = false;
      }
    };

    const saveValuesReorder = async () => {
      if (isSaving.value) return;
      isSaving.value = true;
      try {
        const ids = values.value.map(x => x.id).filter(Boolean);
        await store.dispatch("postDatas", {
          api: "PropertyDefinitions/values/reorder",
          data: ids
        });
        await loadValues();
      } finally {
        isSaving.value = false;
      }
    };

    onBeforeMount(() => {
      if (props.isactive) {
        loadValues();
      }
    });

    watch(
      () => props.isactive,
      val => {
        if (val) {
          loadValues();
        }
      }
    );

    watch(
      () => (props.definition ? props.definition.id : null),
      () => {
        if (props.isactive) {
          loadValues();
        }
      }
    );

    return {
      internalActive,
      values,
      valuesLoaded,
      valueHeads,
      valueOpts,
      addValue,
      editValueModal,
      editValueData,
      openEditValue,
      saveValueEdit,
      deleteValue,
      toggleValue,
      saveValuesReorder,
      errorMessage
    };
  }
};
</script>

<style scoped>
.pv-alert-msg {
  margin-bottom: 8px;
  padding: 8px 10px;
  border-radius: 4px;
  background-color: #ffebee;
  color: #b71c1c;
  font-size: 13px;
}
</style>
